import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=360abe1e&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360abe1e')) {
      api.createRecord('360abe1e', component.options)
    } else {
      api.reload('360abe1e', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=360abe1e&", function () {
      api.rerender('360abe1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/asserts/lib/vue-tabs/components/Tab.vue"
export default component.exports